var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.GET_LAYOUT_LOADING || _vm.GET_LAN_LAYOUT_LOADING,
          expression: "GET_LAYOUT_LOADING || GET_LAN_LAYOUT_LOADING",
        },
      ],
      staticClass: "layout-container transition-linear",
    },
    [
      _c("div", { staticClass: "aside transition-linear" }, [
        _c("div", { staticClass: "asideItem" }, [
          _vm.GET_TOKEN
            ? _c("div", { staticClass: "user" }, [
                _c("div", { staticClass: "userLeft" }, [
                  _c("img", { attrs: { src: _vm.userData.userAvatar } }),
                  _c("span", [_vm._v(_vm._s(_vm.userData.userName))]),
                ]),
                _c("div", {
                  staticClass: "userRight",
                  on: { click: _vm.handleLogout },
                }),
              ])
            : _c("div", { staticClass: "lan-login" }, [
                _c(
                  "div",
                  {
                    staticClass: "lan-login-btn",
                    on: { click: _vm.loginHandle },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("LoginNow")) + " ")]
                ),
                _c("div", { staticClass: "lan-login-text" }, [
                  _vm._v(_vm._s(_vm.$t("view_only_lan"))),
                ]),
              ]),
        ]),
        _c(
          "div",
          { staticClass: "asideItem" },
          [
            _c(
              "div",
              {
                staticClass: "LanPrinter",
                on: {
                  click: function ($event) {
                    _vm.lanOpen = !_vm.lanOpen
                  },
                },
              },
              [
                _c("div", { staticClass: "left font-family-95" }, [
                  _vm._v(_vm._s(_vm.$t("LANPrinter"))),
                ]),
                _c("div", { staticClass: "right" }, [
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.lanOpen,
                        expression: "!lanOpen",
                      },
                    ],
                    attrs: { src: require("../../assets/imgs/closeIcon.png") },
                  }),
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.lanOpen,
                        expression: "lanOpen",
                      },
                    ],
                    attrs: { src: require("../../assets/imgs/openIcon.png") },
                  }),
                ]),
              ]
            ),
            _vm.lanOpen
              ? _vm._l(_vm.GET_LAN_PRINTER_LIST, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "printerItem",
                      class: [
                        _vm.$route.name == "workbench" &&
                          _vm.GET_LAN_MQTT?.uuid == item.uuid &&
                          "selectItem",
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.handleLanPrinter(item)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "left" }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "right",
                          class:
                            item.status == "busy"
                              ? "busy"
                              : item.status == "free"
                              ? "free"
                              : "offline",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                item.status == "busy"
                                  ? "Busy"
                                  : item.status == "free"
                                  ? "Free"
                                  : "Offline"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  )
                })
              : _vm._e(),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "asideItem" },
          [
            _c(
              "div",
              {
                staticClass: "CloudPrinter",
                on: {
                  click: function ($event) {
                    _vm.cloudOpen = !_vm.cloudOpen
                  },
                },
              },
              [
                _c("div", { staticClass: "left font-family-95" }, [
                  _vm._v(_vm._s(_vm.$t("CloudPrinter"))),
                ]),
                _c("div", { staticClass: "right" }, [
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.cloudOpen,
                        expression: "!cloudOpen",
                      },
                    ],
                    attrs: { src: require("../../assets/imgs/closeIcon.png") },
                  }),
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.cloudOpen,
                        expression: "cloudOpen",
                      },
                    ],
                    attrs: { src: require("../../assets/imgs/openIcon.png") },
                  }),
                ]),
              ]
            ),
            _vm.cloudOpen
              ? _vm._l(_vm.GET_CLOUD_PRINTER_LIST, function (item, index) {
                  return _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: index < 20,
                          expression: "index < 20",
                        },
                      ],
                      key: index,
                      staticClass: "printerItem",
                      class: [
                        _vm.$route.name == "workbench" &&
                          _vm.currentPrinter == item.id &&
                          "selectItem",
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.handlePrinter(item)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "left" }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "right",
                          class:
                            _vm.$common.formatterStatus(
                              item.device_status,
                              item.is_printing
                            ) == "Busy"
                              ? "busy"
                              : _vm.$common.formatterStatus(
                                  item.device_status,
                                  item.is_printing
                                ) == "Free"
                              ? "free"
                              : "offline",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  _vm.$common.formatterStatus(
                                    item.device_status,
                                    item.is_printing
                                  )
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  )
                })
              : _vm._e(),
          ],
          2
        ),
        _c("div", { staticClass: "asideItem" }, [
          _c(
            "div",
            {
              staticClass: "CloudPrinter",
              class: [_vm.$route.name == "printerList" && "selectItem"],
              on: { click: _vm.viewList },
            },
            [
              _c("div", { staticClass: "left font-family-95" }, [
                _vm._v(_vm._s(_vm.$t("printer_list"))),
              ]),
              _vm._m(0),
            ]
          ),
        ]),
        _vm.GET_TOKEN
          ? _c("div", { staticClass: "asideItem" }, [
              _c(
                "div",
                {
                  staticClass: "CloudPrinter",
                  class: [_vm.$route.name == "cloudSpace" && "selectItem"],
                  on: { click: _vm.jumpCloudSpace },
                },
                [
                  _c("div", { staticClass: "left font-family-95" }, [
                    _vm._v(_vm._s(_vm.$t("cloud_files"))),
                  ]),
                  _vm._m(1),
                ]
              ),
            ])
          : _vm._e(),
        _c("div", { staticClass: "asideItem" }, [
          _c(
            "div",
            { staticClass: "AddPrinter", on: { click: _vm.addPrinter } },
            [
              _c("div", { staticClass: "left" }, [
                _vm._v(_vm._s(_vm.$t("AddPrinter"))),
              ]),
              _vm._m(2),
            ]
          ),
        ]),
      ]),
      _c("div", { staticClass: "main" }, [
        !_vm.isOnline ||
        (_vm.$route.path == "/workbench" &&
          _vm.lan_mqtt?.haveTip &&
          _vm.lan_mqtt?.haveTip != 0)
          ? _c(
              "div",
              { staticClass: "tip" },
              [
                !_vm.isOnline
                  ? [
                      _vm._v(
                        " " + _vm._s(_vm.$t("network_unavailable_retry")) + " "
                      ),
                    ]
                  : _vm.lan_mqtt?.haveTip == 1
                  ? [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$common.replaceSeat(
                              _vm.$t("retry_tip"),
                              _vm.$global.lanCount - _vm.lan_mqtt.retryCount
                            )
                          ) +
                          " "
                      ),
                    ]
                  : _vm.lan_mqtt?.haveTip == 2
                  ? [_vm._v(" " + _vm._s(_vm.$t("disconnection_tip")) + " ")]
                  : _vm.lan_mqtt?.haveTip == 3
                  ? [
                      _vm._v(" " + _vm._s(_vm.$t("connect_fail_tip")) + " "),
                      _c(
                        "span",
                        { staticClass: "link", on: { click: _vm.retry } },
                        [_vm._v(_vm._s(_vm.$t("Retry")))]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "contentRoute" },
          [
            _c(
              "keep-alive",
              [_vm.$route.meta.keepAlive ? _c("router-view") : _vm._e()],
              1
            ),
            !_vm.$route.meta.keepAlive ? _c("router-view") : _vm._e(),
          ],
          1
        ),
      ]),
      _c("addPrinter", {
        attrs: { visible: _vm.addDialog },
        on: {
          "update:visible": function ($event) {
            _vm.addDialog = $event
          },
          cnSubmit: _vm.cnSubmit,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "right" }, [
      _c("img", { attrs: { src: require("../../assets/imgs/closeIcon.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "right" }, [
      _c("img", { attrs: { src: require("../../assets/imgs/closeIcon.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "right" }, [
      _c("img", { attrs: { src: require("../../assets/imgs/addIcon.png") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }